import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import * as fromDevices from '../../';
import { RouterDto } from '../../../api/core';
import { AppState } from '../../../app.models';
import { registerApiCall } from '../../../utils';

@Component({
    selector: 'liebherr-master-password',
    templateUrl: 'master-password.component.html',
    styleUrls: ['master-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MasterPasswordDialogComponent {
    password$ = new BehaviorSubject<string | undefined>(undefined);
    loading$ = this.store.select(fromDevices.selectLoading);
    hide = true;

    constructor(
        private store: Store<AppState>,
        public dialogRef: MatDialogRef<MasterPasswordDialogComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: RouterDto
    ) {
        if (data.id) {
            registerApiCall(
                () => this.store.dispatch(fromDevices.loadMasterPassword({ id: data.id! })),
                fromDevices.DeviceActionTypes.LOADED_MASTER_PASSWORD
            )
                .pipe(first())
                .subscribe((action) => this.password$.next(action.password));
        }
    }

    onCancel() {
        this.dialogRef.close();
    }
}
